export const actionTypes = {
  REQUEST_START: 'GET_CONFIG.REQUEST_START',
  REQUEST_SUCCESS: 'GET_CONFIG.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'GET_CONFIG.REQUEST_FAILURE',
  RESET: 'GET_CONFIG.RESET',
};

export function startRequest() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}

export function resetConfig() {
  return {
    type: actionTypes.RESET,
  };
}
